<template>
  <div v-show="isVisibleInternal" class="loading-indicator" :class="`loading-indicator--${type}`">
    <div v-if="isSpinnerType" class="loading-indicator__element" />
    <img v-else :src="src" class="loading-indicator__element" alt="loading-indicator" />
  </div>
</template>

<script>
import cloudSrc from 'images/loader/cloud-loader.gif'

export const LOADING_INDICATOR_TYPES = {
  default: 'default', // displays "cloud" as well, but without additional styles for backwards compatibility
  cloud: 'cloud',
  cloudCentered: 'cloud-centered',
  spinner: 'spinner',
}

export default {
  name: 'LoadingIndicator',

  props: {
    /**
     * Toggles visibility.
     */
    isVisible: {
      type: Boolean,
      default: true,
    },
    /**
     * Defines visual type.
     */
    type: {
      type: String,
      default: LOADING_INDICATOR_TYPES.default,
      validator(value) {
        return Object.values(LOADING_INDICATOR_TYPES).includes(value)
      },
    },
    /**
     * Makes it show up only after "displayDelay" has passed.
     */
    hasDelayedDisplay: {
      type: Boolean,
      default: false,
    },
    /**
     * Is only applied if "hasDelayedDisplay" is set to "true".
     */
    displayDelay: {
      type: Number,
      default: 700,
    },
  },

  data() {
    return {
      isVisibleInternal: true,
      displayDelayTimeoutId: null,
      src: cloudSrc,
    }
  },

  computed: {
    isSpinnerType() {
      return this.type === LOADING_INDICATOR_TYPES.spinner
    },
  },

  watch: {
    isVisible: {
      immediate: true,
      handler() {
        if (this.isVisible && this.hasDelayedDisplay) {
          this.displayDelayTimeoutId = setTimeout(() => {
            this.isVisibleInternal = true
          }, this.displayDelay)
        } else {
          clearTimeout(this.displayDelayTimeoutId)
          this.isVisibleInternal = this.isVisible
        }
      },
    },
  },
}
</script>

<style scoped lang="scss">
.loading-indicator {
  // we cannot add "loader" class since styles from loader.scss would be applied

  &--cloud {
    .loading-indicator__element {
      position: relative;
      width: 60px;
      height: 60px;
      transform: translate(-50%, -50%);
    }
  }

  &--cloud-centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 60px;
  }

  &--spinner {
    .loading-indicator__element {
      position: relative;

      &:before {
        @include spinner-centered(28px, $color-black, 1px);
      }
    }
  }
}
</style>
